export default defineNuxtRouteMiddleware((to) => {
  if (to.path !== '/') {
    return
  }

  const {reference, phone_email} = to.query
  if (!reference || !phone_email) {
    return
  }

  return navigateTo({
    path: '/review/',
    query: {
      reference,
      phone_email,
    },
  })
})
